/* @flow */
import React from 'react';
// $FlowIgnore
import moment from 'moment';
import { mapArrayToTsvString } from 'utils/toTsvString';
import DownloadContainer from 'containers/DownloadContainer';
import Tr from 'components/UIKit/Table/Tr';
import Td from 'components/UIKit/Table/Td';
import Icon from 'components/UIKit/Icon/Icon';

type CaseOverviewRowProps = {
  router: Object,
  children: any,
  report: any
}

function CaseOverviewRow({
  children: createdDatetime, router, report
}: CaseOverviewRowProps): React.Element {
  let did = router.location.query.did;
  let { program, project } = router.params;

  return (
    <Tr
      style={{
        backgroundColor: did === createdDatetime ? '#0950C3' : 'transparent',
        color: did === createdDatetime ? '#fff' : '#222'
      }}
      >
      <Td>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <div style={{ lineHeight: 0, marginRight: '1rem' }}>
            <i className="material-icons">assessment</i>
          </div>
          <span>Case Overview Report</span>
        </div>
      </Td>
      <Td>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          { moment(createdDatetime).format('MMM Do YYYY, h:mm a') }
        </div>
      </Td>
      <Td>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: `center`
          }}
        >
          <div style={{ lineHeight: 0, marginRight: '1rem' }}>
            <DownloadContainer
              body={ mapArrayToTsvString(report.map(x => x.report)) }
              format="TSV"
              filename=
                { program && project
                  ? `Case-Overview_${program}-${project}_${createdDatetime}.tsv`
                  : `Case-Overview_All-Projects_${createdDatetime}.tsv`
                }
            >
              <Icon style={{ cursor: `pointer` }}>
                file_download
              </Icon>
            </DownloadContainer>
          </div>
        </div>
      </Td>
    </Tr>
  );
}

export default CaseOverviewRow;
